export const pNumberPattern = /^(01[0-9])-?([0-9]{3,4})-?([0-9]{4})$/
export const certNumberPattern = /^[0-9]+$/

export const NumReplace = (str: string, maxLength: number) => {
  return str.replace(/[^0-9]/g, '').slice(0, maxLength)
}

/** 010 제외 휴대폰 뒷 8자리: 숫자만 추출 후 "1234 5678" 형식 */
export const formatShortPNumber = (str: string) => {
  const digits = str.replace(/[^0-9]/g, '').slice(0, 8)
  if (digits.length <= 4) return digits
  return `${digits.slice(0, 4)} ${digits.slice(4)}`
}
